function normEnrichmentName(s) {
  return String(s || "").trim().toLowerCase();
}

/**
 * Wire a confirmed catalog entity id onto relationship rows that reference the same surface name.
 * Covers rows that already have a stale target_entity_id from auto-resolution (no missing_* fields).
 */
export function wireRelEntityId(rel, entityId, surfaceName, entityType) {
  if (!rel || typeof rel !== "object" || !entityId) return rel;
  const missName = normEnrichmentName(surfaceName);
  const missType = normEnrichmentName(entityType);
  if (!missName || !missType) return rel;

  const clearMissing = (row, end) => ({
    ...row,
    [`${end}_entity_id`]: entityId,
    missing_end: undefined,
    missing_entity_type: undefined,
    missing_surface_name: undefined,
    candidate_matches: [],
  });

  const sameMissing =
    normEnrichmentName(rel?.missing_entity_type) === missType &&
    normEnrichmentName(rel?.missing_surface_name) === missName;
  if (sameMissing) {
    if (rel?.missing_end === "source") return clearMissing(rel, "source");
    if (rel?.missing_end === "target") return clearMissing(rel, "target");
  }
  if (
    normEnrichmentName(rel?.surface_target_name) === missName &&
    normEnrichmentName(rel?.target_entity_type) === missType
  ) {
    return clearMissing(rel, "target");
  }
  if (
    normEnrichmentName(rel?.surface_source_name) === missName &&
    normEnrichmentName(rel?.source_entity_type) === missType
  ) {
    return clearMissing(rel, "source");
  }
  return rel;
}

/**
 * Fill missing_end / missing_surface_name / missing_entity_type from surface_* and type fields.
 * Orchestrator sometimes emits rows with a gap on one end but omits canonical missing_* metadata
 * (e.g. legacy previews); enrichment review UI + approve uses this so "Create entity + approve" works.
 */
export function augmentRelMissingEndpoint(rel) {
  if (!rel || typeof rel !== "object") return rel;
  const sid = String(rel.source_entity_id || "").trim();
  const tid = String(rel.target_entity_id || "").trim();
  if (sid && tid) return rel;

  const out = { ...rel };
  let me = String(out.missing_end || "").trim();
  if (!me) {
    const rt = String(out.relationship_type || "").trim();
    if (rt === "consumer_from_provider" && !sid && tid) me = "source";
    else if (rt === "provider_to_consumer" && sid && !tid) me = "target";
    else if (
      (rt === "initiative affects application" ||
        rt === "organization uses application") &&
      sid &&
      !tid
    ) {
      me = "source";
    }     else if (rt === "application runs on platform" && sid && !tid) {
      me = "target";
    } else if (rt === "application runs on platform" && !sid && tid) {
      me = "source";
    } else if (sid && !tid) me = "target";
    else if (!sid && tid) me = "source";
    else me = "target";
  }
  out.missing_end = me;

  let ms = String(out.missing_surface_name || "").trim();
  let mt = String(out.missing_entity_type || "").trim();

  if (me === "target") {
    if (!ms) {
      ms = String(
        out.surface_target_name ||
          out.surface_other_application ||
          out.surface_child_application ||
          ""
      ).trim();
    }
    if (!mt) mt = String(out.target_entity_type || "").trim();
  } else if (me === "source") {
    if (!ms) {
      ms = String(
        out.surface_source_name || out.surface_other_application || ""
      ).trim();
    }
    if (!mt) mt = String(out.source_entity_type || "").trim();
  }

  if (ms) out.missing_surface_name = ms;
  if (mt) out.missing_entity_type = mt;

  return out;
}
